export enum AuthTarget {
  cms = 'cms',
  totara = 'totara'
}
